module.exports = __webpack_public_path__ + "static/media/pfp.6a4e6395.png";